<script>
/**
 * PopupForm.vue
 * A modal based form that pops up over the current page when the :show prop is true. Add your form as a slot inside of
 * this popup
 */
import MediumModal from '@/Components/Modals/MediumModal'
import Spinner from '@/Components/Icons/Spinner.vue'
export default {
  components: { MediumModal, Spinner },
  props: {
    /**
     * If true this modal will display on the screen
     */
    show: {
      type: Boolean,
      default: false
    },

    /**
     * The title that appears at the top of the modal
     */
    title: {
      type: String,
      default: ''
    },

    /**
     * The text that appears on the cancel button
     */
    cancel: {
      type: String,
      default: 'Cancel'
    },

    /**
     * The text that appears on the "confirm" button
     */
    button: {
      type: String,
      default: 'Submit'
    },

    submitting: {
      type: Boolean,
      default: false
    }
  }
}
</script>

<template>
  <medium-modal
    :is-open="show"
    @close="$emit('close')"
  >
    <template #header>
      {{ title }}
    </template>

    <div class="mt-4">
      <slot />
    </div>

    <template #footer>
      <button
        type="button"
        @click="$emit('close')"
        class="btn px-6 py-2 bg-gray-100 border border-gray-400 text-blue-600 ml-3 font-semibold"
      >
        {{ cancel }}
      </button>
      <button
        type="button"
        @click="$emit('confirm')"
        class="btn px-6 py-2 ml-2 bg-blue-600 text-gray-100 font-bold"
      >
        <span>
          {{ button }}
        </span>
        <Spinner
          v-if="submitting"
          class="text-gray-100 ml-2"
        />
      </button>
    </template>
  </medium-modal>
</template>
